<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch" >
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Tabela de Consumo de Ração</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmTabela" label="Nome da Tabela" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md4 lg4>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.sgTipoUep" :items="tiposUnidadesExploracao"
                        color="primary" item-text="dsTipoUnidadeExploracao" item-value="csTipoUnidadeExploracao" label="Tipo"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.sgSexo" :items="tiposGenero"
                        color="primary" item-text="dsSexo" item-value="sgSexo" label="Gênero dos animais"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout row justify-center v-if="registro.idTabelaConsumoRacao > 0">
            <v-flex sm2 xs2 md1>
                <DialogCadastroPontoTabela @saved="savePontoTabelaSelected" @closeDialog="closeDialogPontoTabela" @openDialog="openDialogPontoTabela"
                    :rec="atualPontoTabela" :dialog="dialogPontoTabela" labelItem="Dia" labelValor="Qt Consumo" @deleted="beforeDeleteItemTabela"/>
            </v-flex>
            <v-flex sm12 xs12 md10 mt-2>
                <h3 >
                    <b>Pontos da Tabela</b>
                </h3>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center pa-3 pt-0 v-if="registro.idTabelaConsumoRacao > 0">
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" @click:row="editPonto" no-results-text="Nenhum registro encontrado" :loading="isLoadingPontosTabela"
                    :items="registro.pontos" color="secondary" loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-layout justify-center pa-3 v-if="registro.idTabelaConsumoRacao > 0">
            <v-flex sm11 xs11 md11 lg12>
                <OneLineGraph v-if="exibeGrafico" :values="seriesPontos" :valueName="'Consumo Desejado'" :xName="'Dias alojados'" :yName="'Consumo (kg)'" 
                    :finalizadorValor="' kg'"/>
            </v-flex>
        </v-layout>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import OneLineGraph from "@/components/general/OneLineGraph.vue"
import DialogCadastroPontoTabela from "@/components/dialogs/DialogCadastroPontoTabela.vue"

export default {
    name: 'TabelaConsumoRacao',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        OneLineGraph,
        DialogCadastroPontoTabela,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            headers: [
                { text: "Dias", value: "nrDia", sortable: false },
                { text: "Qt Consumo", value: "qtConsumo", sortable: false },
            ],
            isLoadingPontosTabela: false,
            dialogPontoTabela: false,
            atualPontoTabela: {},
            seriesPontos: {
                nrDias: [],
                valor: [],
            },
            exibeGrafico: false,
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Tabela de Consumo de Ração: ' + this.registro.idTabelaConsumoRacao

                return 'Inserindo nova Tabela de Consumo de Ração'
            }
        },
        tiposUnidadesExploracao () {
            return this.$store.state.tiposUnidadesExploracaoSemUpl
        },
        tiposGenero () {
            return this.$store.state.tiposGenero
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        savePontoTabelaSelected(record) {
            var context = this
            this.exibeGrafico = false
            var itemPoint = {
                idTabelaConsumoRacaoPontos: record.idTabelaPontos,
                cdTabelaConsumoRacao: parseInt(this.$route.params.id),
                nrDia: record.nrDia,
                qtConsumo: record.valor
            }
            if (itemPoint.idTabelaConsumoRacaoPontos != null)
            {
                context.$axios.put('tabela-consumo-racao-pontos/' + itemPoint.idTabelaConsumoRacaoPontos, itemPoint)
                    .then(() => {
                        context.getRegistro(context.$route.params.id)
                    })
            }
            else
            {
                context.$axios.post('tabela-consumo-racao-pontos/', itemPoint)
                    .then(() => {
                        context.getRegistro(context.$route.params.id)
                    })
            }
            context.atualPontoTabela = {}
        },
        closeDialogPontoTabela() {
            this.atualPontoTabela = {}
            this.dialogPontoTabela = false
        },
        openDialogPontoTabela() {
            this.dialogPontoTabela = true
        },
        editPonto(item) {
            this.dialogPontoTabela = true
            var itemPoint = {
                idTabelaPontos: item.idTabelaConsumoRacaoPontos,
                nrDia: item.nrDia,
                valor: item.qtConsumo
            }
            this.atualPontoTabela = itemPoint
        },
        beforeDeleteItemTabela(item) {
            this.atualPontoTabela = item
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteItemTabela()
            })
        },
        deleteItemTabela() {
            var context = this
            this.exibeGrafico = false
            this.$axios.delete('tabela-consumo-racao-pontos/' + this.atualPontoTabela.idTabelaPontos)
                .then(() => {
                    context.getRegistro(context.$route.params.id)
                    context.closeDialogPontoTabela()
                })
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
                this.exibeGrafico = true
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            var context = this
            this.exibeGrafico = false
            this.$axios.get('tabela-consumo-racao/' + id)
                .then((response) => {
                    var rec = response.data[0].data
                    this.registro = Object.assign({}, rec)
                    this.registroBanco = Object.assign({}, rec)

                    this.registro.pontos.sort( (a, b) => {
                        return a.nrDia - b.nrDia
                    })

                    this.registroBanco.pontos.sort( (a, b) => {
                        return a.nrDia - b.nrDia
                    })

                    context.seriesPontos.nrDias = []
                    context.seriesPontos.valor = []
                    
                    context.registro.pontos.forEach(i => {
                        context.seriesPontos.nrDias.push(i.nrDia)
                        context.seriesPontos.valor.push(i.qtConsumo)
                    })

                    this.changeViewState('endLoading')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                    this.$router.push({ path: '/tabelaConsumoRacao'})
                })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.$axios.post('tabela-consumo-racao/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'tabelaConsumoRacao', params: { id: response.data[0].data.idTabelaConsumoRacao }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadTabelasConsumoRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.$axios.put('tabela-consumo-racao/' + this.registro.idTabelaConsumoRacao, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadTabelasConsumoRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('tabela-consumo-racao/' + this.registro.idTabelaConsumoRacao)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadTabelasConsumoRacao')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/tabelaConsumoRacao' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idTabelaConsumoRacao: 0,
                nmTabela: '',
                sgTipoUep: '',
                sgSexo: '',
                pontos: [],
            }
            this.registroBanco = {
                idTabelaConsumoRacao: 0,
                nmTabela: '',
                sgTipoUep: '',
                sgSexo: '',
                pontos: [],
            }
        },
        goSearch() {
            this.$router.push({ path: '/tabelaConsumoRacaoSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
